import React from 'react';
import { motion } from 'framer-motion';
import { growthSteps } from '../../data/invest';
import { fadeUp } from '../../utils/motion';
export function InvestGrowth() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1351" data-mp="2z00t02xvzw0d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1352" data-mp="2z095htq3kzb1">
        <motion.h2 {...fadeUp} className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl tracking-tight leading-tight" data-id="element-1353" data-mp="2u30h3becvz1c">
          How we plan to grow
        </motion.h2>
        <motion.ol {...fadeUp} className="lg:col-span-7 border-t border-white/15" data-id="element-1354" data-mp="3mrxsqvo2axl4">
          {growthSteps.map((step, index) => <li key={step.title} className="flex gap-5 border-b border-white/15 py-6" data-id="element-1355" data-mp="3d0jx4yz8ehx9" data-mpi={index}>
              <span className="font-heading font-bold text-teal w-6 shrink-0 pt-0.5" data-id="element-1356" data-mp="eabcllhjc25k">{index + 1}</span>
              <div data-id="element-1357" data-mp="9ijix2331gb7">
                <h3 className="font-heading font-bold text-xl mb-2" data-id="element-1358" data-mp="9i0bifb26abf">{step.title}</h3>
                <p className="text-white/75 leading-relaxed" data-id="element-1359" data-mp="26i0vd5elryu8">{step.body}</p>
              </div>
            </li>)}
        </motion.ol>
      </div>
    </section>;
}